import {initFlow} from "../../store/actions/system/FlowActions";
import {USER_LOGOUT} from "../../store/reducers/system/UserReducer";
import {error as errorToast} from "../../store/actions/system/ToastAction";

/**
 * Centralized error handler for API responses
 * Handles specific error tokens as defined in KLB API documentation
 * 
 * @param {Function} getState - Redux getState function
 * @param {Function} dispatch - Redux dispatch function
 * @param {Object} error - Error object from API
 * @param {boolean} silent - Whether to silence error toasts
 */
export const handleError = (getState, dispatch, error, silent = false) => {
    let reThrow = true;
    
    // Check if error is in expected format
    if (!error || typeof error !== 'object') {
        if (!silent) errorToast('api_error_unknown', true);
        return;
    }
    
    switch (error.token) {
        // Authentication errors
        case 'error_authentication_required':
        case 'error_login_required':
            dispatch(initFlow());
            dispatch({type: USER_LOGOUT});
            break;
            
        // Token errors
        case 'invalid_request_token':
            reThrow = false;
            if (typeof window !== 'undefined')
                window.location.reload();
            break;
            
        // Permission errors
        case 'error_access_denied':
            // Use the error token directly since it's already a translation key
            if (!silent) errorToast('error_access_denied', true);
            break;
            
        // Rate limiting
        case 'error_rate_limit_exceeded':
            if (!silent) errorToast('api_error_rate_limit', true);
            break;
            
        // Validation errors
        case 'error_missing_field':
            if (!silent) errorToast('api_error_missing_field', true);
            break;
            
        case 'error_invalid_value':
            // Use error.message if available, otherwise fallback to translation
            if (!silent) {
                if (error.message) {
                    errorToast(error.message, false);
                } else {
                    errorToast('api_error_invalid_value', true);
                }
            }
            break;
            
        // Not found
        case 'error_not_found':
            if (!silent) errorToast('api_error_not_found', true);
            break;
            
        // Method not allowed
        case 'http_method_not_allowed':
            if (!silent) errorToast('api_error_method_not_allowed', true);
            break;
            
        // Timeout
        case 'error_execution_timeout':
            if (!silent) errorToast('api_error_timeout', true);
            break;
            
        // Default case for all other errors
        default:
            // For other errors, prioritize the original error message from API
            // If no message, try using the token as translation key
            // Final fallback to generic error message
            if (!silent) {
                if (error.message) {
                    errorToast(error.message, false);
                } else if (error.error) {
                    errorToast(error.error, false);
                } else if (error.token && typeof error.token === 'string') {
                    // Try using the error token as a translation key
                    errorToast(error.token, true);
                } else {
                    // Generic fallback
                    errorToast('api_error_generic', true);
                }
            }
            break;
    }

    if (reThrow) throw error;
};
